import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SessionDataService } from 'inova-front-core/session';

@Directive({
  selector: '[serviceRequired]'
})
export class ServiceRequiredDirective {

  @Input('serviceRequired') set appHideForRole(serviceName: string) {
    if(serviceName && serviceName.length>0){
      let hasService = this.sessionService.userHasService(serviceName);
      if (hasService) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
      else {
        this.viewContainer.clear();
      }
    }
    else{
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef,  private sessionService:SessionDataService) { }

}
